<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-01-17 15:50:57
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-11 13:59:54
 * @FilePath: \manage_property_IMd:\app\reps\chongqin\manage_property\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <router-view v-if="isRouterAlive" />
</template>
<script setup>
import { ref, provide, nextTick } from 'vue';
const isRouterAlive = ref(true);
const reload = () => {
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
};
provide('reload', reload);
</script>
<style lang="scss"></style>
